import React from "react";
import { Button } from "@material-ui/core";
import classnames from "classnames";
import classes from "./LoadingButton.module.scss";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

interface LoadingButtonProps {
  text: string;
  onAction?: () => void;
  disabled: boolean;
  loading: boolean;
  width: number;
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  text,
  onAction,
  disabled,
  loading,
  width = 150,
}) => {
  return (
    <Button
      className={classnames(classes.loadingButton, {
        [classes.disabledButton]: disabled,
      })}
      onClick={onAction}
      disabled={disabled}
      id="LoadingButton"
      variant="contained"
      color="primary"
      style={{ minWidth: `${width}px` }}
    >
      {loading ? <LoadingSpinner size={24} color="white" /> : text}
    </Button>
  );
};

export default LoadingButton;
